import { Typography } from '@prenuvo/halo-foundation';

import { api } from '@/api';
import { formatTimeStampToUTC } from '@/shared/util';

type ActivityLogHeaderProps = {
  actor: string;
  timestamp: string;
};

export function ActivityLogHeader({ actor, timestamp }: ActivityLogHeaderProps) {
  const { data } = api.pii.patient.query.useGetPatient({
    payload: {
      params: {
        user_id: actor,
      },
    },
  });

  return (
    <div className="flex border-b pb-1">
      <Typography className="content-center" variant="paragraph-sm-bold">
        {formatTimeStampToUTC(timestamp)}
      </Typography>
      <Typography as="label" className="ml-auto italic">
        {data?.[0]?.fullname}
      </Typography>
    </div>
  );
}
